var renderingCartTemplates = require('./renderTemplate');
var renderingPaymentTemplates = require('antavo_custom/renderPaymentSummaryTemplate');
var handleReward = require('antavo_custom/handleReward');
var DOMPurify = require('dompurify');
/**
 * Updates product image dimensions
 * @param {Object} data - AJAX response from the server
 */
function updateProductImage(data) {
    if (data.deviceType === 'desktop') {
        if (data.items.length) {
            var productImgDimension = data.items[0].imageDimentions.desktop.cart;
            $('.product-image').each(function () {
                var imgSrc = $(this).attr('src');
                var dimensionParam = imgSrc.split('?');
                var updatedImgSrc = `${dimensionParam[0]}${productImgDimension}`;
                $(this).attr('src', updatedImgSrc);
            });
        }
    }
}

/**
 * Handle promotion code error message
 * @param {Object} data Error object
 * @param {boolean} applyCode If called from Apply promotion
 */
function handlePromotionCodeError(data, applyCode) {
    var $promotionCodeBox = $('.promotion-code__formdata .promo-code-box');
    var promoCode = $.each($promotionCodeBox, function () {
        return $(this).val() ? $(this).val() : '';
    });
    if (!!promoCode || applyCode) {
        $('.cartmerge-error').addClass('d-none');
        $promotionCodeBox.addClass('is-error').attr('aria-describedby', 'invalidCouponCode');
        $('.promo-code-box-label').addClass('is-error');
        if (promoCode) {
            if (data.errorMessage) {
                $('.code-error-message').empty().append(DOMPurify.sanitize(data.errorMessage));
                $('.promotion-code--error').removeClass('d-none');
                if (data.errorMessageDetailModalInfo) {
                    $('.promo-error-message-detail').empty().append(DOMPurify.sanitize(data.errorMessageDetailModalInfo));
                    if ($('.code-error-message-detail').hasClass('d-none')) {
                        $('.code-error-message-detail').removeClass('d-none');
                    }
                } else {
                    $('.code-error-message-detail').addClass('d-none');
                }
            }
        } else if (applyCode) {
            const errorMessage = $('.promotion-code--error').attr('data-missing');
            $('.code-error-message').empty().append(DOMPurify.sanitize(errorMessage));
        }
    }
}

/**
 * Reset promotion code error in cart
 */
function resetPromotionCodeError() {
    $('.promotion-code--item').css('border-bottom-color', '#d8d8d8');
    $('.code-error-message').empty();
    $('.promo-code-error .promotion-error .cart-error_message').empty();
    $('.promo-code-error .promotion-error .icon-alert').addClass('d-none');
    $('.promotion-error-buttonMsg').addClass('d-none');
    $('.promotion-code--error').addClass('d-none');
    // $('.icon-success-check').addClass('d-none');
    $('.promo-code-box').removeClass('is-error');
    $('.global-alert .payment-error').empty();
}

/**
 * Handle show hide on Edit product
 */
function cartCheckoutShowHideItems() {
    var checkoutStageValue = $('.data-checkout-stage').data('checkout-stage');
    if (checkoutStageValue === 'shipping' || checkoutStageValue === 'payment') {
        $('.checkout-edit').each(function () {
            $(this).show();
        });
        $('.cart-edit').each(function () {
            $(this).hide();
        });
    } else {
        $('.checkout-edit').each(function () {
            $(this).hide();
        });
        $('.inStock').removeClass('d-none').addClass('d-block');
        $('.cart-edit').each(function () {
            $(this).show();
        });
    }
}

/**
 * Remove repeated coupon promotion messages
 */
function removeRepeatedPromoMessage() {
    var couponPromotionRelationship = [];
    var $list = $('.coupon-promotion-relationship');
    $('li', $list).each(function () {
        couponPromotionRelationship.push($(this).text());
    });

    $list.empty();

    var uniqueCouponPromotionRelationship = [];
    $.each(couponPromotionRelationship, function (i, el) {
        if ($.inArray(el, uniqueCouponPromotionRelationship) === -1) {
            uniqueCouponPromotionRelationship.push(el);
        }
    });

    $.each(uniqueCouponPromotionRelationship, function (i, el) {
        $list.append('<li>' + el + '</li>');
    });
}

/**
 * Update coupon and promo html in order summary
 * @param {string} discountsHtml discount markupText
 */
function updateCouponsAndPromos(discountsHtml) {
    $('.coupons-and-promos').empty().append(discountsHtml);
    removeRepeatedPromoMessage();
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseModalHTML(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.product-quickview');
    var carousel = $html.find('.quickview__modal__images');
    var cartEdit = $html.find('.cart-edit-mob').html();
    var footer = $html.find('.desk-footer .cart-and-ipay');

    return { body: body, footer: footer, cartEdit: cartEdit, carousel: carousel };
}

/**
 * This appen HTML model to body element. This takes promotion name and detils as a string
 * @param {string} promotionName - name of the promotion
 * @param {string} promotionDetail - detail of the promotion
 *
 */
function getModalHtmlElement(promotionName, promotionDetail) {
    var eligiblePromotionPopupTitle = $('.eligiblePromotionPopupTitle').val();
    if ($('#PromotionID').length !== 0) {
        $('#PromotionID').remove();
    }

    var htmlString = `<div aria-hidden="true" aria-labelledby="promotionDetailModal"
        class="modal ds-content-promotion-modal ds-content-delivery-modal modal-animated fade"
        id="PromotionID" role="dialog" tabindex="-1">
        <div class="modal-dialog modal-large modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="headline sm">${DOMPurify.sanitize(eligiblePromotionPopupTitle)}</h5>
                    <button type="button" class="close ds-close" data-dismiss="modal" aria-label="Close">
                        <span class="icon-close"></span>
                    </button>
                </div>
                <div class="modal-body ds-modal-body-center">
                    <div class="ds-text-center">
                        <div class="headline md name">${DOMPurify.sanitize(promotionName)}</div>
                        <div class="body-font xs details">${DOMPurify.sanitize(promotionDetail)}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>`;
    $('body').append(htmlString);
}


$('body').on('click', '.eligible-promotion-modal', function () {
    var promotionName = $(this).data('promotionName');
    var promotionDetail = $(this).data('promotionDetail');
    getModalHtmlElement(promotionName, promotionDetail);
});

/**
 * This function takes an array of the promortions and return a HTML.
 * This is useful when there is "buy 2 get one free" or "20% off any 2" type of promortion applied.
 * This function disply callout message on all those two products which assign with that promotion.
 * @param {Array} promotions - available promotions array
 *
 * @return {string} - return a string of a HTML or empty string based on condition.
 */
function displayEligiblePromotions(promotions) {
    var promotionToDisplay = promotions.map(productPromotion => {
        if (productPromotion.calloutMsg !== '' && productPromotion.displayeligibleproductPromoMsg) {
            return `<div class="d-flex flex-row promotion-mesages">
                <svg class="icon-carts">
                    <use xlink:href="#offer-tag"></use>
                </svg>
                <span class="promotion-message-text">
                    ${productPromotion.calloutMsg}
                </span>
                <a href="#" data-toggle="modal" data-promotion-name="${productPromotion.name}" data-promotion-detail="${productPromotion.details}" data-target="#PromotionID" class="eligible-promotion-modal ml-1 ${productPromotion.calloutMsg ? '' : 'empty-promo'}">
                    <span class="promotion-callout-details">Details</span>
                </a>
            </div>`;
        }
        return '';
    });
    return promotionToDisplay;
}

/**
 * update promotions details
 * @param {Object} data - items basket line items list
 * @param {string} attr - items from checkout
 */
function updatePromotions(data, attr) {
    var $appliedPromoCode = $('.applied-promo-code');
    var $promoCodeForm = $('.promotion-code__formdata');
    var $promoCodeHeader = $('.promotion-code--header');
    var couponCode = $('input[id="couponCode"]:visible', this).val() || $($('.applied-promo-code')[0]).text();
    var discounts = data.totals.discounts;
    var items = attr === 'checkout' ? data.items.items : data.items;
    var isPromoCodeApplied = false;
    if (discounts.length) {
        discounts.find(function (discount) {
            if (discount.type === 'coupon' && !discount.isLoyaltyCoupon) {
                if (discount.couponCode.toLowerCase() === couponCode.toLowerCase()) {
                    isPromoCodeApplied = true;
                }
            }
        });
    }
    items.forEach(function (item, index) {
        var isPromoExistsNotApplied = (data.totals.discounts.length > 0 && couponCode.length);
        resetPromotionCodeError();
        if (data.valid && data.valid.promotionError && data.valid.message) {
            $('.promo-code-error .cart-error-msg').addClass('promotion-error');
            $('.promo-code-error .promotion-error .cart-error_message').empty().append(data.valid.message);
            $('.promo-code-error .promotion-error .icon-alert').removeClass('d-none');
            $('.promo-code-error .cart-error-messaging').removeClass('d-none');
        }
        updateCouponsAndPromos(data.totals.discountsHtml);
        handleReward.handleCheckboxState();
        if (isPromoExistsNotApplied) {
            // set Promotion code error if discount exists but is not applied
            const errorMessage = $('.coupon-promotion-message').val();
            const errorMessageDetailModalInfo = $('.coupon-promotion-details').val();
            handlePromotionCodeError({
                errorMessage,
                errorMessageDetailModalInfo
            });
        }
        var $productLineItem = $('.item-' + item.UUID);
        if (item.renderedPromotions && !item.entireStyleOOS) {
            $productLineItem.empty().append(item.renderedPromotions);
        } else if (item.promotions && item.promotions.length > 0) {
            $productLineItem.empty().append(displayEligiblePromotions(item.promotions));
        } else if (item.entireStyleOOS) {
            $productLineItem.empty();
        }
        if (!items[index].isBonusProductLineItem && !item.entireStyleOOS) {
            $('.uuid-' + item.UUID + ' .unit-price').empty().append(item.renderedPrice);
            $('.line-item-price-' + item.UUID + ' .unit-price').empty().append(item.renderedPrice);
            $('.item-total-' + item.UUID).empty().append(item.priceTotal.renderedPrice);
        }
        if (couponCode && isPromoCodeApplied) {
            $appliedPromoCode.text(couponCode);
            $promoCodeForm.addClass('has-promo');
            $promoCodeHeader.addClass('disabled').removeClass('enabled');
        } else {
            $promoCodeForm.removeClass('has-promo');
        }
    });
}


/**
 * Update order summary in cart page
 * @param {Object} data cart objects
 */
function updateOrderSummary(data) {
    var freeShipping = 'FREE';
    let orderDiscountItems = '';
    let paymentOrderDiscountItems = '';
    let $shippingCost = $('.selected-shipping-cost');

    if (data.totals.shippingAmountTotal.value === 0) {
        $shippingCost
        .empty()
        .append(freeShipping)
        .addClass('shipping-cost-free');
        $('.shipping-method-name').empty().append(data.totals.shippingAmountTotal.shippingMethodName + ' Shipping');
    } else {
        $shippingCost
            .empty()
            .append(data.totals.shippingAmountTotal.formatted);
        if ($shippingCost.hasClass('shipping-cost-free')) {
            $shippingCost.removeClass('shipping-cost-free');
        }
        $('.shipping-method-name').empty().append(data.totals.shippingAmountTotal.shippingMethodName + ' Shipping');
    }
    $('.tax-total').empty().append(data.totals.totalTax);

    // for US site we are using this key to show grand total
    if ($('.grand-total-sum').hasClass('order-cost-item-value')) {
        $('.grand-total-sum').empty().append(data.totals.grandTotal);
    } else if ($('.page').data('sitename') === 'PVHCKUS' || $('.page').data('sitename') === 'PVHTHUS') {
        $('.grand-total-sum').empty().append(data.totals.totalNetPrice);
    } else {
        $('.grand-total-sum').empty().append(data.totals.subTotal);
    }

    let KlarnaMax;
    let KlarnaMin;
    if ($('.klarna-express-checkout').length > 0) {
        KlarnaMax = $('.klarna-express-checkout').data('klarnamaxorderamount');
        KlarnaMin = $('.klarna-express-checkout').data('klarnaminorderamount');
        if (parseFloat(data.totals.grandTotal.split('$')[1]) >= parseFloat(KlarnaMin) && parseFloat(data.totals.grandTotal.split('$')[1]) <= parseFloat(KlarnaMax)) {
            $('.klarna-express-checkout-container.klarnamaindiv').removeClass('d-none');
        } else {
            $('.klarna-express-checkout-container.klarnamaindiv').addClass('d-none');
        }
    }

    if ($('.page').hasClass('checkout') && $('.express-checkout-continue').length && $('.express-checkout-continue').data('klarnaonlyenabled') === true) {
        if (parseFloat(data.totals.grandTotal.split('$')[1]) >= parseFloat(KlarnaMin) && parseFloat(data.totals.grandTotal.split('$')[1]) <= parseFloat(KlarnaMax)) {
            $('.express-checkout-continue').removeClass('klarnaonly-hide');
            $('.express-checkout-continue').addClass('klarnaonly-enabled');
        } else if (!(parseFloat(data.totals.grandTotal.split('$')[1]) >= parseFloat(KlarnaMin) && parseFloat(data.totals.grandTotal.split('$')[1]) <= parseFloat(KlarnaMax))) {
            $('.express-checkout-continue').removeClass('klarnaonly-enabled');
            $('.express-checkout-continue').addClass('klarnaonly-hide');
        }
    }

    if ($('.page').hasClass('checkout') && $('.express-checkout-continue').length && $('.express-checkout-continue').data('applepayklarnaonlyenabled') === true) {
        if (parseFloat(data.totals.grandTotal.split('$')[1]) >= parseFloat(KlarnaMin) && parseFloat(data.totals.grandTotal.split('$')[1]) <= parseFloat(KlarnaMax)) {
            $('.express-checkout-continue').removeClass('applepayklarnaonly-hide');
            $('.express-checkout-continue').addClass('applepayklarnaonly-enabled');
        } else if (!(parseFloat(data.totals.grandTotal.split('$')[1]) >= parseFloat(KlarnaMin) && parseFloat(data.totals.grandTotal.split('$')[1]) <= parseFloat(KlarnaMax))) {
            $('.express-checkout-continue').removeClass('applepayklarnaonly-enabled');
            $('.express-checkout-continue').addClass('applepayklarnaonly-hide');
        }
    }

    // for CA site we are using this key to show grand total
    if (data.totals.subTotal) {
        $('.estimated-cost-subtotal').empty().append(data.totals.subTotal);
    }
    // for US site we are using this key to show subtotal
    $('.sub-total').empty().append(data.totals.subTotal);

    // for CA site we are using this key to show subtotal
    if (data.totals.subTotalWithoutOrderDiscount) {
        $('.sub-total-without-discount').empty().append(data.totals.subTotalWithoutOrderDiscount);
    }

    // Order level discounts
    data.totals.discounts.forEach(function (item) {
        const renderItem = renderingCartTemplates.renderHTMLForOrderTotalsDiscounts(item, data.totals.shippingAmountTotal.value);
        const renderPaymentItem = renderingPaymentTemplates.renderHTMLForOrderTotalsDiscounts(item);
        orderDiscountItems += renderItem;
        paymentOrderDiscountItems += renderPaymentItem;
    });

    $('.order-level-discount-section').empty().html(orderDiscountItems);
    $('.orderLevelDiscountWrapper').empty().html(paymentOrderDiscountItems);

    if (data.totals.orderLevelDiscountTotal.value > 0) {
        $('.order-discount').removeClass('hide-order-discount');
        $('.order-discount-total').empty()
            .append('- ' + data.totals.orderLevelDiscountTotal.formatted);
    } else {
        $('.order-discount').addClass('hide-order-discount');
        $('.order-discount-total').empty()
            .append('- ' + data.totals.orderLevelDiscountTotal.formatted);
    }

    // Total Saving on cart(Label: 'You Saved')
    $('.total-saving').empty().append(data.totals.totalSavings.formatted);

    var $loyaltyContainer = $('.cart-page .loyalty-info-message');
    if (!!data.loyaltyMessage && $loyaltyContainer.length) {
        $loyaltyContainer.removeClass('d-none');
        $('.cart-page .loyalty-info-message > p').empty().append(data.loyaltyMessage);
    }

    if (data.antavoRewardPoints && !!data.antavoRewardPoints.points) {
        $('.antavo-points').empty().html(data.antavoRewardPoints.points);
    }

    if (data.totals.shippingLevelDiscountTotal.value > 0) {
        $('.shipping-discount').removeClass('hide-shipping-discount');
        $('.shipping-discount-total').empty().append('- ' +
            data.totals.shippingLevelDiscountTotal.formatted);
    } else {
        $('.shipping-discount').addClass('hide-shipping-discount');
    }

    if (data.totals.giftCardTotals && data.totals.giftCardTotals.giftCardTotalAmount.value > 0) {
        $('.gift-card-total-amt').text('-' + data.totals.giftCardTotals.giftCardTotalAmount.formatted);
        $('.gift-card-item').removeClass('d-none');
    } else {
        $('.gift-card-item').addClass('d-none');
    }

    if ($('#checkout-main').length && ($('#checkout-main').attr('data-checkout-stage') === 'payment')) {
        if (data.totals.giftCardTotals) {
            $('.applied-card-container').html('');

            data.totals.giftCardTotals.appliedGiftCard.forEach(function (item, index) {
                let $appliedCard = $('.applied-card-placeholder').clone();
                $appliedCard.find('.applied-card__amount').text(item);
                $appliedCard.find('a.remove').data('cardnumber', data.totals.giftCardTotals.giftCardno[index]);
                $appliedCard.removeClass('applied-card-placeholder d-none');
                $appliedCard.addClass('applied-card');
                $('.applied-card-container').append($appliedCard);
            });
        }
    }
}

/**
 * get Empty cart message
 * @param {string} message error messages
 * @returns {string} HTML markup
 */
function getEmptyCartMessage(message) {
    return `<div class="row">
                <div class="col-12 text-center">
                    <h1> ${message}</h1>
                </div>
            </div>`;
}

/**
 * Toggle cart icon based on basket number of items
 * @param {number} numItems number of items
 */
function toggleCartIcon(numItems) {
    var $miniCart = $('.minicart');
    if ($miniCart.length > 0) {
        var $miniCartCountDesktop = $miniCart.find('.total-count-minicart .minicart-number');
        var $miniCartCountMobile = $miniCart.find('.total-count-minicart-mobile .minicart-number');
        var $miniCartStyleMobile = $miniCart.find('.minicart-mobile .icon-cart-container');
        var $miniCartStyleDesktop = $miniCart.find('.language-selctor-enable .icon-cart-container');
        var $cartCount = $miniCart.find('#cartCount');
        $('.minicart-link')
            .find('.icon-cart-container , .icon-cart-container.minicart-mobile')
            .empty()
            .html('<span class=icon-bag-filled></span>');
        if (numItems === 0) {
            $('.minicart-link')
                .find('.icon-cart-container')
                .empty()
                .html('<span class=icon-bag></span>');
            $miniCartCountDesktop.add($miniCartCountMobile).addClass('mincart-noitems');
            $miniCartCountDesktop[0].innerText = $miniCartCountMobile[0].innerText = '';
        } else if (numItems > 99) {
            $miniCartCountDesktop.add($miniCartCountMobile).removeClass('mincart-noitems');
            $miniCartCountDesktop[0].innerText = $miniCartCountMobile[0].innerText = $cartCount[0].value;
            $miniCartCountDesktop.addClass('count-updated-large');
            $miniCartCountMobile.addClass('count-updated-large');
            $miniCartStyleMobile.add($miniCartStyleDesktop).addClass('count-updated-large');
        } else {
            $miniCartCountDesktop.add($miniCartCountMobile).removeClass('mincart-noitems');
            $miniCartCountDesktop.removeClass('count-updated-large');
            $miniCartCountMobile.removeClass('count-updated-large');
            $miniCartStyleMobile.add($miniCartStyleDesktop).removeClass('count-updated-large');
            $miniCartCountDesktop[0].innerText = $miniCartCountMobile[0].innerText = numItems;
            if (numItems > 9) {
                $miniCartCountDesktop.addClass('count-updated');
                $miniCartCountMobile.addClass('count-updated');
                $miniCartStyleMobile.add($miniCartStyleDesktop).addClass('count-updated');
            } else {
                $miniCartCountDesktop.removeClass('count-updated');
                $miniCartCountMobile.removeClass('count-updated');
                $miniCartStyleMobile.add($miniCartStyleDesktop).removeClass('count-updated');
            }
        }
    }
}


/**
 * update mini cart with cart count
 * @param {Object} data basket data objects
 */
function updateMiniCart(data) {
    $('.number-of-items').empty().append(data.resources.numberOfItems);
    $('.minicart-quantity').empty().append(data.numItems);
    $('.minicart-link').attr({
        'aria-label': data.resources.minicartCountOfItems,
        title: data.resources.minicartCountOfItems
    });
    toggleCartIcon(data.numItems);
}

/**
 * reset mini cart popover if exists
 */
function resetMiniCartPopover() {
    $('.minicart .popover').empty();
    $('.minicart .popover').removeClass('show');
}

/**
 * Re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCartTotals(data) {
    $('.cart-total-items').empty().html('(' + data.resources.numberOfItems + ')');
    updateOrderSummary(data);
    updatePromotions(data);
    if ($('.minicart').length) {
        updateMiniCart(data);
    }
    cartCheckoutShowHideItems();
    updateProductImage(data);
    var hideAfterpay = $('.hide-afterpay-preorder');
    var hideAfterpayMsg = $('.klarna-afterpay-messaging');
    var hideAfterinModal = $('#cart-page-wrapper');
    hideAfterpayMsg.removeClass('hide-afterpay-messaging');
    hideAfterinModal.removeClass('hide-afterpay-inmodal');
    if (data.hasPreOrderItems) {
        hideAfterpay.addClass('d-none');
        hideAfterpayMsg.addClass('hide-afterpay-messaging');
        hideAfterinModal.addClass('hide-afterpay-inmodal');
    } else {
        hideAfterpay.removeClass('d-none');
        hideAfterpayMsg.removeClass('hide-afterpay-messaging');
        hideAfterinModal.removeClass('hide-afterpay-inmodal');
    }
    if (data.allActiveInactiveRewards) {
        handleReward.rewardsResponse(data);
        handleReward.handleCheckboxState();
    }
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 */
function createErrorNotification(message) {
    var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
        'fade show" role="alert">' +
        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        '<span aria-hidden="true">&times;</span>' +
        '</button>' + message + '</div>';

    $('.cart-error').append(errorHtml);
}

/**
 * Updates availability messages
 * @param {Object} lineItem - AJAX response from the server
 * @returns {string} - returns a string of availability message.
 */
function availabilityMessage(lineItem) {
    var messages = '';
    if (lineItem.availability.preOrder && lineItem.availability.cartMessage.length > 1) {
        messages += '<p class="line-item-attributes">' + lineItem.availability.cartMessage[1] + lineItem.availability.preOrderCartMessage + '</p>';
    } else if (lineItem.availability.preOrder) {
        messages += '<p class="line-item-attributes"> <span>' + lineItem.availability.cartMessage[0] + ' </span> <span class="pre-order-date">' + lineItem.availability.preOrderCartMessage + '</span> </p>';
        // eslint-disable-next-line no-undef
    } else if ((lineItem.hazmatProduct && lineItem.showShippingMsg) || (!lineItem.hazmatProduct)) {
        lineItem.availability.cartMessage.forEach(function (message) {
            const stockAvail = (message === 'In Stock' ? 'instock-cart-msg' : 'stock-avail-msg');
            messages += '<p class="line-item-attributes"> <span class="' + stockAvail + '">' + message + '</span> <span class="ship-msg-cart">' + lineItem.availability.stockShippingMsg + '</span> </p>';
        });
    } else {
        lineItem.availability.cartMessage.forEach(function (message) {
            messages += '<p class="line-item-attributes d-flex">' + message + '</p>';
        });
    }
    return messages;
}

/**
 * Updates the availability of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateAvailability(data, uuid) {
    var lineItem;
    var messages = '';

    for (var i = 0; i < data.items.length; i++) {
        if (data.items[i].UUID === uuid) {
            lineItem = data.items[i];
            break;
        }
    }
    if (lineItem != null) {
        var $lineItemAvailability = $('.availability-' + lineItem.UUID);
        $lineItemAvailability.empty();
        if (data.valid.error) {
            lineItem.availability.messages.forEach(function (message) {
                messages += '<span class="line-item-attributes">' + message + '</span>';
            });
        } else if (lineItem.availability) {
            if (lineItem.availability.cartMessage) {
                messages = availabilityMessage(lineItem);
            }
        }
        $lineItemAvailability.html(messages);
    }
    $('.js-product--list').html(data.renderTemplate);
}

/**
 * Checks whether the basket is valid. if invalid displays error message and disables
 * checkout button
 * @param {Object} data - AJAX response from the server
 */
function validateBasket(data) {
    $('.cartmerge-error').addClass('d-none');
    if (data.valid.error) {
        if (!data.valid.message) {
            $('.cart').empty().append(getEmptyCartMessage(data.resources.emptyCartMsg));
            if ($('.minicart').length) {
                updateMiniCart(data);
            }
            resetMiniCartPopover();
        }
    } else {
        $('.valid-cart-error').find('button').trigger('click');
        $('.cartmerge-error').addClass('d-none');
        $('.checkout-btn').removeClass('disabled');
    }
}

/**
 * re-renders the approaching discount messages
 * @param {Object} approachingDiscounts - updated approaching discounts for the cart
 */
function updateApproachingDiscounts(approachingDiscounts) {
    var html = '';
    var orderHtml = '';
    $('.approaching-discounts').empty();
    $('.order-approaching-discounts').empty();
    if (approachingDiscounts.length > 0) {
        approachingDiscounts.forEach(function (item) {
            if (!item) return;
            if (!item.isOrderLevelPromotion) {
                html += '<div class="ds-progress-bar progress-bar-small shopping-progress">' +
                '<progress class="ds-progress ds-progress--secondary" value="' + item.merchandiseTotal + '"max="' + item.conditionThreshold + '"></progress></div><div class="single-approaching-discount">'
                + item.discountMsg + '</div>';
            } else {
                orderHtml += '<div class="ds-progress-bar progress-bar-small shopping-progress">' +
                '<progress class="ds-progress ds-progress--secondary" value="' + item.merchandiseTotal + '"max="' + item.conditionThreshold + '"></progress></div><div class="single-approaching-discount">'
                + item.discountMsg + '</div>';
            }
        });
    }
    $('.approaching-discounts').append(html);
    $('.order-approaching-discounts').append(orderHtml);
}

/**
 * re-renders the approaching discount messages
 * @param {Object} data - cart object/ cartModel/ basketModel
 */
function updateCartComponents(data) {
    updateCartTotals(data);
    updateCouponsAndPromos(data.totals.discountsHtml);
    updateApproachingDiscounts(data.approachingDiscounts);
    validateBasket(data);
    var noQtyError = !data.qtyValid || (data.qtyValid && !data.qtyValid.error);
    if (!data.valid.error && noQtyError && $('.cart-error-messaging')) {
        $('.cart-error-messaging').addClass('d-none');
        $('.buttonErrorMessage').addClass('d-none');
    } else if ($('div.ds-cart-error-messaging').length && !noQtyError) {
        $('.cart-qty-error .cart-error_message').empty().append(data.qtyValid.message);
        $('.cart-qty-error').removeClass('d-none');
        $('html, body').animate({ scrollTop: 0 }, 200);
    }
    $('.checkoutanalyticscta').data('checkoutanalyticsdata', { cartAnalyticsData: data.cartAnalyticsData, priceAndSize: data.checkoutAnalyticsPriceAndSize });
    var cartHeaderTotalItemsLabel = $('.cart-header-total-items').val();
    var cartHeaderTotalItemLabel = $('.cart-header-single-item').val();
    var cartHeaderCountLabel = data.numItems > 1 ? cartHeaderTotalItemsLabel : cartHeaderTotalItemLabel;
    $('.cart-header__description', '.shopping-bag').html(DOMPurify.sanitize(cartHeaderCountLabel.replace('{0}', data.numItems)));
    $('.cart-header__description').attr('data-tealiumitemquantity', data.numItems);
    let cartItemCount = data.numItems > 1 ? '(' + data.numItems + ' items)' : '(' + data.numItems + ' item)';
    $('.order-summary__title .summary-item-count').empty().append(cartItemCount);
    if (data.numItems > 1) {
        $('.order-summary-inner').removeClass('single-cart-item').addClass('multi-cart-item');
    } else {
        $('.order-summary-inner').removeClass('multi-cart-item').addClass('single-cart-item');
    }

    if (data.items.length) {
        const $cartPage = $('.cart');
        if (data.action && data.action.indexOf('Cart') !== -1) {
            if (!$('.loyalty-info-message .tooltip-wrapper').length) {
                if (data.antavoRewardPoints && data.antavoRewardPoints.points >= 0) {
                    var html = '<input type="hidden" class="loyalty-info-message-points" value="' + data.antavoRewardPoints.points + '" />';
                    $('.loyalty-info-message .tooltip-wrapper').empty().append(html);
                    $('.order-summary-container .loyalty-rewards-box-model-cart .points-display, .device-summary-msg .loyalty-rewards-box-model-cart .points-display').html(data.antavoRewardPoints.points);
                    $('.order-summary-container, .device-loyalty-pointscontainer').removeClass('hide-antavo-copy');
                    if (data.antavoRewardPoints.points === 0) {
                        $('.order-summary-container, .device-loyalty-pointscontainer').addClass('hide-antavo-copy');
                    }
                }
            }
            $cartPage.addClass('has-cart-items, cart-page');
            $('.shipping--intro').removeClass('d-none');
            $cartPage.removeClass('cart-empty');
        }
    } else {
        const $cartPage = $('.cart');
        $cartPage.removeClass('has-cart-items, cart-page');
        $('.shipping--intro').addClass('d-none');
        $cartPage.addClass('cart-empty');
    }
}

export {
    cartCheckoutShowHideItems,
    createErrorNotification,
    getEmptyCartMessage,
    handlePromotionCodeError,
    parseModalHTML,
    resetMiniCartPopover,
    resetPromotionCodeError,
    updateApproachingDiscounts,
    updateAvailability,
    updateCartTotals,
    updateCouponsAndPromos,
    updateMiniCart,
    updateProductImage,
    updatePromotions,
    removeRepeatedPromoMessage,
    validateBasket,
    updateCartComponents
};
